export const bacteriaLayoutConfig_bwccore_eng = [
    {
        label: 'Akkermansia muciniphila',
        page: 5,
        yOffset: 190,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 180,
        yResult: 180,
        yResulttext: 184,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 5,
        yOffset: 229,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 219,
        yResult: 219,
        yResulttext: 223,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 5,
        yOffset: 268,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 258,
        yResult: 258,
        yResulttext: 262,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 5,
        yOffset: 307,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 297,
        yResult: 297,
        yResulttext: 301,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Clostridium cluster IV',
        page: 5,
        yOffset: 346,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 336,
        yResult: 336,
        yResulttext: 340,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Enterococcus genus',
        page: 5,
        yOffset: 385,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 375,
        yResult: 375,
        yResulttext: 379,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 5,
        yOffset: 424,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 414,
        yResult: 414,
        yResulttext: 418,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 5,
        yOffset: 463,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 453,
        yResult: 453,
        yResulttext: 457,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus genus',
        page: 5,
        yOffset: 502,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 492,
        yResult: 492,
        yResulttext: 496,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 5,
        yOffset: 595,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 585,
        yResult: 585,
        yResulttext: 589,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 5,
        yOffset: 634,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 624,
        yResult: 624,
        yResulttext: 628,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 5,
        yOffset: 673,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 663,
        yResult: 663,
        yResulttext: 667,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 5,
        yOffset: 712,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 702,
        yResult: 702,
        yResulttext: 706,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 5,
        yOffset: 751,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 741,
        yResult: 741,
        yResulttext: 745,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 5,
        yOffset: 790,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 780,
        yResult: 780,
        yResulttext: 784,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 9,
        yOffset: 105,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 95,
        yResult: 780,
        yResulttext: 99,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 9,
        yOffset: 278,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 268,
        yResult: 780,
        yResulttext: 272,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 9,
        yOffset: 451,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 441,
        yResult: 780,
        yResulttext: 445,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 9,
        yOffset: 690,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 680,
        yResult: 780,
        yResulttext: 684,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Clostridium cluster IV',
        page: 10,
        yOffset: 62,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 52,
        yResult: 780,
        yResulttext: 56,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Enterococcus genus',
        page: 10,
        yOffset: 234,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 224,
        yResult: 780,
        yResulttext: 228,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 10,
        yOffset: 497,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 487,
        yResult: 780,
        yResulttext: 491,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 10,
        yOffset: 781,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 771,
        yResult: 780,
        yResulttext: 775,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Ruminococcus genus',
        page: 11,
        yOffset: 70,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 60,
        yResult: 780,
        yResulttext: 64,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 11,
        yOffset: 316,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 306,
        yResult: 780,
        yResulttext: 310,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 11,
        yOffset: 558,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 548,
        yResult: 780,
        yResulttext: 552,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 12,
        yOffset: 70,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 60,
        yResult: 780,
        yResulttext: 64,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 12,
        yOffset: 313,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 303,
        yResult: 780,
        yResulttext: 307,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 12,
        yOffset: 598,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 588,
        yResult: 780,
        yResulttext: 592,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 13,
        yOffset: 70,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 60,
        yResult: 780,
        yResulttext: 64,
        xResulttext: 555,
        show_result: false
    },
];

export const bacteriaLayoutConfig_bwccore_thai = [
    {
        label: 'Akkermansia muciniphila',
        page: 4,
        yOffset: 190,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 180,
        yResult: 180,
        yResulttext: 184,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Alistipes putredinis',
        page: 4,
        yOffset: 229,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 219,
        yResult: 219,
        yResulttext: 223,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroides genus',
        page: 4,
        yOffset: 268,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 258,
        yResult: 258,
        yResulttext: 262,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bacteroides fragilis',
        page: 4,
        yOffset: 307,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 297,
        yResult: 297,
        yResulttext: 301,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Clostridium cluster IV',
        page: 4,
        yOffset: 346,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 336,
        yResult: 336,
        yResulttext: 340,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Enterococcus genus',
        page: 4,
        yOffset: 385,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 375,
        yResult: 375,
        yResulttext: 379,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 4,
        yOffset: 424,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 414,
        yResult: 414,
        yResulttext: 418,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Roseburia hominis',
        page: 4,
        yOffset: 463,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 453,
        yResult: 453,
        yResulttext: 457,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Ruminococcus genus',
        page: 4,
        yOffset: 502,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 492,
        yResult: 492,
        yResulttext: 496,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 4,
        yOffset: 595,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 585,
        yResult: 585,
        yResulttext: 589,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Bifidobacterium longum',
        page: 4,
        yOffset: 634,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 624,
        yResult: 624,
        yResulttext: 628,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 4,
        yOffset: 673,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 663,
        yResult: 663,
        yResulttext: 667,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus gasseri',
        page: 4,
        yOffset: 712,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 702,
        yResult: 702,
        yResulttext: 706,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus plantarum',
        page: 4,
        yOffset: 751,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 741,
        yResult: 741,
        yResulttext: 745,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 4,
        yOffset: 790,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 780,
        yResult: 780,
        yResulttext: 784,
        xResulttext: 555,
        show_result: true
    },
    {
        label: 'Akkermansia muciniphila',
        page: 8,
        yOffset: 108,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 98,
        yResult: 780,
        yResulttext: 102,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Alistipes putredinis',
        page: 8,
        yOffset: 266,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 256,
        yResult: 780,
        yResulttext: 260,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroides genus',
        page: 8,
        yOffset: 440,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 430,
        yResult: 772,
        yResulttext: 434,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bacteroides fragilis',
        page: 8,
        yOffset: 658,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 648,
        yResult: 780,
        yResulttext: 652,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Clostridium cluster IV',
        page: 9,
        yOffset: 67,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 57,
        yResult: 780,
        yResulttext: 61,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Enterococcus genus',
        page: 9,
        yOffset: 330,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 320,
        yResult: 780,
        yResulttext: 324,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Faecalibacterium prausnitzii',
        page: 9,
        yOffset: 590,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 580,
        yResult: 780,
        yResulttext: 584,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Roseburia hominis',
        page: 10,
        yOffset: 73,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 63,
        yResult: 780,
        yResulttext: 67,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Ruminococcus genus',
        page: 10,
        yOffset: 293,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 283,
        yResult: 780,
        yResulttext: 287,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium bifidum',
        page: 10,
        yOffset: 526,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 516,
        yResult: 780,
        yResulttext: 520,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Bifidobacterium longum',
        page: 10,
        yOffset: 768,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 758,
        yResult: 780,
        yResulttext: 762,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus acidophilus',
        page: 11,
        yOffset: 75,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 65,
        yResult: 780,
        yResulttext: 69,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus gasseri',
        page: 11,
        yOffset: 320,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 310,
        yResult: 780,
        yResulttext: 314,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus plantarum',
        page: 11,
        yOffset: 600,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 590,
        yResult: 780,
        yResulttext: 594,
        xResulttext: 555,
        show_result: false
    },
    {
        label: 'Lactobacillus rhamnosus',
        page: 12,
        yOffset: 75,
        xLabel: 70,
        xBarStart: 280,
        xBarGap: 53,
        xResult: 675,
        yLabel: 65,
        yResult: 780,
        yResulttext: 69,
        xResulttext: 555,
        show_result: false
    },
];